import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import RouterHandler from "../../common/components/RouterHandler.react";
import { FormattedHTMLMessage } from "react-intl";
import { Link } from "react-router";
import Sidebar from "react-sidebar";
import MenuLeft from "../components/menuLeft.react";
import MenuTop from "../components/menuTop.react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";
import { fromJS } from "immutable";

export default class Page extends Component {
  static propTypes = {
    msg: PropTypes.object,
    users: PropTypes.object
  };

  onSetSidebarOpen = open => {
    const { actions } = this.props;
    actions.setSidebar("open", open);
  };

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const { actions, notificationSystem } = this.props;

    this.loadMenuLeft();

    actions.getLocales().then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      }
    });
  }

  componentDidUpdate(prevProps) {
    const { users: { currentUser: prevCurrentUser } } = prevProps;
    const {
      settings: { shouldMenuLeftRerender },
      actions,
      users: { currentUser }
    } = this.props;
    if (shouldMenuLeftRerender) {
      actions.setShouldMenuLeftRerender(false);
      this.loadMenuLeft();
    }
    if (!prevCurrentUser && currentUser) {
      this.loadMenuLeft();
    }
  }

  loadMenuLeft = () => {
    const {
      actions,
      notificationSystem,
      pages: { pages: { meta: pagesMeta } },
      mediaCategories: { mediaCategories: { meta: mediaCategoriesMeta } },
      templates: { templates: { meta: templatesMeta } },
      pagesLists: {
        pagesLists: { meta: pagesListsMeta, sort: pagesListsSort }
      },
      intl,
      users: { currentUser }
    } = this.props;

    let isAdmin = false;
    let isDeveloper = false;

    if (currentUser) {
      currentUser.get("groups").forEach(function(group) {
        if ("admin" === group.name) {
          isAdmin = true;
        }
        if ("developer" === group.name) {
          isDeveloper = true;
        }
      });
    }

    actions.getPages(pagesMeta).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        const menuItems = payload.result.pages.map(function(pageUID, index) {
          const page = payload.entities.pages[pageUID];
          const menuItem = {
            type: "menuItem",
            text: page.pageTranslations[intl.selectedLanguage]
              ? page.pageTranslations[intl.selectedLanguage].name
              : page.pageTranslations["pl"].name,
            link: page.pageTranslations[intl.selectedLanguage]
              ? `/pages/${page.pageTranslations[intl.selectedLanguage].slug}`
              : `pages/${page.pageTranslations["pl"].slug}`
            // icon: {
            //   className:'icon',
            //   source:'/assets/img/icon_circle.svg'
            // }
          };
          return menuItem;
        });

        menuItems.unshift({
          type: "menuItem",
          text: "wszystkie",
          link: `/pages`,
          icon: {
            className: "icon",
            source: "/assets/img/icon_squares.svg"
          },
          visibleFor: ["admin", "developer", "user"]
        });

        actions.addMenuItems(
          fromJS({
            type: "submenu",
            text: "Strony",
            name: "pages",
            link: "/pages",
            icon: {
              className: "icon",
              source: "/assets/img/icon_contracts.svg"
            },
            visibleFor: ["admin", "developer", "user"],
            items: menuItems
          }),
          ["pages"]
        );
      }
    });

    actions
      .getMediaCategories(mediaCategoriesMeta)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          const menuItems = payload.result.mediaCategories.map(function(
            mediaCategoryUID,
            index
          ) {
            const mediaCategory =
              payload.entities.mediaCategories[mediaCategoryUID];
            const menuItem = {
              type: "menuItem",
              text: mediaCategory.name,
              link: `/mediaCategories/${mediaCategory.uid}`
              // icon: {
              //   className:'icon',
              //   source:'/assets/img/icon_circle.svg'
              // }
            };
            return menuItem;
          });

          menuItems.unshift({
            type: "menuItem",
            text: "wszystkie",
            link: `/mediaCategories`,
            icon: {
              className: "icon",
              source: "/assets/img/icon_squares.svg"
            },
            visibleFor: ["admin", "developer", "user"]
          });

          actions.addMenuItems(
            fromJS({
              type: "submenu",
              text: "Media",
              name: "mediaCategories",
              link: "/mediaCategories",
              icon: {
                className: "icon",
                source: "/assets/img/icon_media.svg"
              },
              visibleFor: ["admin", "developer", "user"],
              items: menuItems
            }),
            ["mediaCategories"]
          );
        }
      });

    if (isDeveloper) {
      actions.getTemplates(templatesMeta).then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          const menuItems = payload.result.templates.map(function(
            templateUID,
            index
          ) {
            const template = payload.entities.templates[templateUID];
            const menuItem = {
              type: "menuItem",
              text: template.name,
              link: `/templates/${template.uid}`
              // icon: {
              //   className:'icon',
              //   source:'/assets/img/icon_circle.svg'
              // }
            };
            return menuItem;
          });

          menuItems.unshift({
            type: "menuItem",
            text: "wszystkie",
            link: `/templates`,
            icon: {
              className: "icon",
              source: "/assets/img/icon_squares.svg"
            },
            visibleFor: ["developer"]
          });

          actions.addMenuItems(
            fromJS({
              type: "submenu",
              text: "Templatki",
              name: "templates",
              link: "/templates",
              icon: {
                className: "icon",
                source: "/assets/img/icon_contracts.svg"
              },
              visibleFor: ["developer"],
              items: menuItems
            }),
            ["templates"]
          );
        }
      });

      actions
        .getPagesLists(pagesListsMeta, pagesListsSort)
        .then(({ error, payload }) => {
          if (error) {
            addNotificationsForInvalidFields(payload, notificationSystem);
          } else {
            const menuItems = payload.result.pageLists.map(function(
              pageListUID,
              index
            ) {
              const pageList = payload.entities.pagesLists[pageListUID];
              const menuItem = {
                type: "menuItem",
                text: pageList.name,
                link: `/pagesLists/${pageList.slug}`
                // icon: {
                //   className:'icon',
                //   source:'/assets/img/icon_circle.svg'
                // }
              };
              return menuItem;
            });

            menuItems.unshift({
              type: "menuItem",
              text: "wszystkie",
              link: `/pagesLists`,
              icon: {
                className: "icon",
                source: "/assets/img/icon_squares.svg"
              },
              visibleFor: ["developer"]
            });

            actions.addMenuItems(
              fromJS({
                type: "submenu",
                text: "Listy stron",
                name: "pagesLists",
                link: "/pagesLists",
                icon: {
                  className: "icon",
                  source: "/assets/img/icon_contracts.svg"
                },
                visibleFor: ["developer"],
                items: menuItems
              }),
              ["pagesLists"]
            );
          }
        });
    }
  };

  render() {
    const {
      msg,
      actions,
      settings,
      location: { pathname },
      users: { viewer, currentUser },
      menu,
      history
    } = this.props;

    const sidebarContent = (
      <MenuLeft
        msg={msg.app.menuLeft}
        {...{ currentUser, actions, pathname }}
        menu={menu}
        actions={actions}
        history={history}
      />
    );

    let connected = "";
    if (settings.online) {
      connected = "Połączono!";
    } else {
      connected = "Brak połączenia z internetem!";
    }

    return (
      <div className="is-logged-wrapper">
        <Sidebar
          sidebar={sidebarContent}
          open={settings.sidebar.open}
          docked={settings.sidebar.docked}
          onSetOpen={this.onSetSidebarOpen}
          transitions={true}
          touch={false}
        >
          <div
            id="wrapper"
            className="col-xs-12 col-sm-12 col-md-12 col-lg-12 start-xs top-xs wrapper"
          >
            <div className="row">
              <MenuTop {...this.props} />
            </div>

            <RouterHandler {...this.props} />
          </div>
        </Sidebar>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/isLogged/Page.react.js